import React from 'react';

import {StyledPillBadge} from './styled';
import {convertHoursSla} from 'utils/date';

interface BadgesProps {
    data: string | number;
}

const Badges: React.FC<BadgesProps> = ({data}) => {
	const badgeColor = (): string => {
		if (typeof data === 'number') {
			if (data >= 8) {
				return '#27AD61';
			} else if (data > 0 && data < 8) {
				return '#F7AB20';
			} else {
				return '#EB5757';
			}
		}
		return '#EB5757';
	};

	const renderContent = (): string | number => {
		if (typeof data === 'number') {
			return convertHoursSla(data);
		}
		return data;
	};

	return <StyledPillBadge $bg={badgeColor()}>{renderContent()}</StyledPillBadge>;
}

export default Badges;
